import React from "react";
import Card from "../ui/Card";
import Skeleton from "../ui/Skeleton";

export const ClientCompaniesSkeleton: React.FC = () => {
  return (
    <div className="w-full space-y-3">
      {/* Toolbar — grudada na description bar (-mt-4 -mx-4), não mais um
          card flutuante. */}
      <div className="-mt-4 -mx-4 px-4 py-2 mb-4 bg-white/95 border-b border-purple-200 flex flex-col gap-3">
        <div className="flex flex-row flex-wrap gap-2.5 items-center">
          <div className="flex-1 min-w-[200px] sm:min-w-[250px]">
            <Skeleton
              variant="rectangular"
              width="100%"
              height={36}
              className="rounded-xl"
            />
          </div>
          <div className="hidden lg:flex items-center gap-2 shrink-0 mx-2">
            {[90, 110, 110].map((w, i) => (
              <Skeleton
                key={i}
                variant="rectangular"
                width={w}
                height={32}
                className="rounded-full opacity-30"
              />
            ))}
          </div>
          <div className="shrink-0 ml-auto">
            <Skeleton
              variant="rectangular"
              width={90}
              height={36}
              className="rounded-lg opacity-40"
            />
          </div>
        </div>
      </div>

      {/* Grid de cards — mesma geometria de ClientCompanyCard.tsx
          (avatar 48px rounded-xl, p-4 sm:p-5, rounded-2xl). */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
        {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
          <Card
            key={i}
            className="rounded-2xl border-purple-200 shadow-xs overflow-hidden bg-white"
          >
            <div className="p-4 sm:p-5 flex items-start gap-4">
              <Skeleton
                variant="rectangular"
                width={48}
                height={48}
                className="rounded-xl shrink-0"
              />
              <div className="flex-1 space-y-2 min-w-0">
                <Skeleton variant="text" width="75%" height={16} />
                <Skeleton
                  variant="rectangular"
                  width={90}
                  height={16}
                  className="rounded-md opacity-40"
                />
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
};

export default ClientCompaniesSkeleton;
